import { render, staticRenderFns } from "./ModalSuccessPayment.vue?vue&type=template&id=759fa4c2&"
import script from "./ModalSuccessPayment.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports